import React from 'react';
import type { ActionType, StateType } from 'typesafe-actions';

import type { ModalPayload } from 'src/modules/ConfirmModal/types';
import * as actions from './actions';
import reducer, { initialState } from './reducer';

type Dispatch = (action: ActionType<typeof actions>) => void;
export type Context = [state: StateType<typeof reducer>, dispatch: Dispatch];
const context = React.createContext<Context>([initialState, () => {}]);

let savedRef: Context;

export const ConfirmModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = React.useReducer(reducer, initialState);
  React.useEffect(() => {
    savedRef = value;
  }, [value]);
  return <context.Provider value={value}>{children}</context.Provider>;
};

type Api = {
  open: (payload: ModalPayload) => void;
  close: () => void;
};

export const api: Api = {
  open: (payload) => {
    const [, dispatch] = savedRef;
    return dispatch(actions.open(payload));
  },
  close: () => {
    const [, dispatch] = savedRef;
    return dispatch(actions.close());
  },
};

export default context;
